export default __webpack_public_path__ + "static/ambient-logo-trans-f32b8d1253193c1a87107ae1ea45d444.png";